<template>
	<article class="event post-event">
		<div class="event__inner">
			<div class="event__meta">
				<div class="date">
					<span class="date__start" v-if="startDate">
						<span class="date__start_month">{{getMonth(startDate)}}</span>
						<span class="date__start_day">{{getDay(startDate)}}</span>
					</span>
				</div>

				<div class="event-actions">
					<a
						class="toggle-calendar"
						:class="{active: calendarOpen}"
						@keyup.enter.prevent="toggleCalendar()"
						@click.prevent="toggleCalendar()"
						href="#"
						aria-label="Save to Calendar"
					>
						<i class="fal fa-calendar-plus"></i>
					</a>

					<div class="calendar-links" v-show="calendarOpen">
						<ul>
							<li>
								<a :href="gCal" class="google" target="_blank" rel="nofollow">Google calendar</a>
							</li>
							<li>
								<a :href="iCal" target="_blank">Outlook/iCal</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="event__details">
				<h3 class="event__details__title">{{event.title}}</h3>
				<div class="event__details__content">
					<ul>
						<li class="location" v-if="location">
							<span class="event__location">{{location}}</span>
						</li>

						<li class="time" v-if="allDay || startTime">
							<span class="time__all-day" v-if="allDay">All Day</span>
							<span class="time__start" v-else>{{startTime}}</span>
							<span class="separator" v-if="endTime && !allDay">&mdash;</span>
							<span class="time__start" v-if="endTime && !allDay">{{endTime}}</span>
						</li>

						<!-- <li class="info_url" v-if="url">
							<a class="event__info_url" :href="url" :title="url">Register</a>
						</li>-->
					</ul>
				</div>
			</div>
		</div>
		<div class="event__footer">
			<div class="event-description" v-if="description" v-html="description"></div>

			<div
				v-if="event.thumbnail_url"
				class="event-thumbnail"
				:style="{ backgroundImage: 'url(' + event.thumbnail_url + ')', backgroundColor: '#ccc' }"
			>
				<div class="event-thumbnail__inner"></div>
			</div>
		</div>
	</article>
</template>

<script>
import moment from "moment";

export default {
	name: "events-list-item",
	data() {
		return {
			data: this.$store.state,
			descriptionOpen: false,
			calendarOpen: false
		};
	},
	props: ["event"],
	computed: {
		gCal: function() {
			// console.log(this.$props.event);

			return this.$props.event.gCalUrl;
		},
		iCal: function() {
			return this.$props.event.iCalUrl;
		},
		description: function() {
			return this.$props.event.info.description;
		},
		location: function() {
			return this.$props.event.info.location;
		},
		url: function() {
			return this.$props.event.info.url;
		},
		startDate: function() {
			return this.$props.event.dates.startDate;
		},
		endDate: function() {
			return this.$props.event.dates.endDate;
		},
		startTime: function() {
			let start = this.$props.event.dates.startTime;
			return start;
		},
		endTime: function() {
			return this.$props.event.dates.endTime;
		},
		allDay: function() {
			return this.$props.event.dates.allDay;
		}
	},
	methods: {
		toggleDescription: function() {
			this.descriptionOpen = !this.descriptionOpen;
			this.calendarOpen = false;
		},
		toggleCalendar: function() {
			this.calendarOpen = !this.calendarOpen;
			this.descriptionOpen = false;
		},
		getDay(date) {
			return moment(date).format("D");
		},
		getMonth(date) {
			return moment(date).format("MMM");
		},
		formatDate(date) {
			return moment(date).format("MMMM DD");
		},
		formatTime(date) {
			// return moment(time, ["HH:mm"]).format("h:mm A");
			return moment(date).format("h:mm A");
		},
		generateUUID() {
			// Public Domain/MIT
			var d = new Date().getTime();
			if (
				typeof performance !== "undefined" &&
				typeof performance.now === "function"
			) {
				d += performance.now(); //use high-precision timer if available
			}
			return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
				/[xy]/g,
				function(c) {
					var r = (d + Math.random() * 16) % 16 | 0;
					d = Math.floor(d / 16);
					return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
				}
			);
		}
	}
};
</script>

<style>
</style>
